module.exports = __webpack_public_path__ + "static/media/clouds.7b10c467.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Day/clouds.svg
// module id = 403
// module chunks = 0